module.exports = __webpack_public_path__ + "img/LOGO_White.65b3a3e8.png";